import { EmptyState as EmptyStateComponent, EmptyStateShade } from "./EmptyState";

export const EmptyState = Object.assign(EmptyStateComponent, {
  Shade: EmptyStateShade
});